import { audioPlayerStorage } from '$logic/audio-player/storage'

export function setData(roomId: string, iid: number) {
  return audioPlayerStorage.setData({ roomId, iid })
}

export function getData() {
  return audioPlayerStorage.getData()
}
